import { render, staticRenderFns } from "./companyOwnedDetail.vue?vue&type=template&id=4c5986e6&"
import script from "./companyOwnedDetail.vue?vue&type=script&lang=ts&"
export * from "./companyOwnedDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports